export default __webpack_public_path__ + "static/media/about.325f6c67.jpg";